import "./page-partner-program.scss";
import "../../js/core";
import "../../../assets/src/eos/js/video-youtube-iframe";
import "../../components/site-elements/sliders/slider-card-blog/slider-card-blog";
import "../../components/site-elements/sliders/section-slider-partners/section-slider-partners";

$(function () {
  import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(() => {
    import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(() => {
        $(".slider-card-blog").owlCarousel({
          responsive: {
            0: {
              items: 1,
              dots: false,
            },
            768: {
              items: 2,
              dots: true,
            },
            992: {
              items: 3,
              dots: true,
            },
          },
          loop: false,
          nav: true,
          dotsEach: true,
          slideBy: 1,
          margin: 20,
          smartSpeed: 200,
        });

        $(".js-media-slider").owlCarousel({
          responsive: {
            0: {
              items: 1,
            },
            768: {
              items: 2,
            },
            992: {
              items: 3,
            },
          },
          loop: false,
          nav: true,
          dots: false,
          dotsEach: false,
          slideBy: 1,
          margin: 20,
          lazyLoad: true,
          smartSpeed: 200,
        });

        $('.js-partners-slider').owlCarousel({
          responsive: {
            568: {
              items: 3,
              slideBy: 1,
            },

            768: {
              items: 3,
              slideBy: 1,
              margin: 20,
            },
          },
          nav: true,
          dots: false,
          items: 2,
          slideBy: 1,
          loop: true,
          smartSpeed: 200,
          // margin: 18
        });

        $(".js-slider-video").owlCarousel({
          responsive: {
            0: {
              items: 1,
              dots: false,
            },
            768: {
              items: 1,
              dots: true,
            },
          },
          nav: true,
          dotsEach: true,
          margin: 20,
          smartSpeed: 200,
        });
        $('.owl-carousel').each(function(index) {
            $(this).find('.owl-nav, .owl-dots').wrapAll("<div class='owl-controls'></div>");
        });
    });
  });
});

$(function () {
  import(/* webpackChunkName: "chunk.owl-carousel" */ 'owl.carousel/src/js/owl.carousel').then(()=>{
    import(/* webpackChunkName: "chunk.owl-carousel-navigation" */ 'owl.carousel/src/js/owl.navigation').then(() => {
      var owl = $('.owl-carousel');
      owl.owlCarousel({
        responsive: {
          0: {
            items: 1,
            dots: false,
          },
          600: {
            items: 2,
            dots: true,
          },
          1024: {
            items: 3,
            dots: true,
          },
        },
        loop: true,
        autoplayTimeout: 7000,
        smartSpeed: 800,
        nav: true,
        dot: true,
        margin: 24,
        smartSpeed: 200,
      });

      owl.on('change.owl.carousel', function (event) {
        let slider = document.getElementById('js-about-us-slider');
        let sliderItems = slider.querySelectorAll('.owl-item');
        sliderItems.forEach(function (sliderItem) {
          let iframe = sliderItem.querySelector('iframe.video-media');
          if (iframe) {
            let re = /autoplay=1/gi;
            let iframeURL = iframe.src;
            let iframeNewURL = iframeURL.replace(re, 'autoplay=0');
            iframe.src = iframeNewURL;
          }
        });
      });
    });
  });
});
